import { Component, Inject, Input, OnInit } from '@angular/core';
import { EmailContentService } from 'src/app/email-content.service';
import { TokenHolder, TOKEN_HOLDER } from '../communication-button/TokenHolder';

@Component({
  selector: 'app-envelope-button',
  templateUrl: './envelope-button.component.html',
  styleUrls: ['./envelope-button.component.css']
})
export class EnvelopeButtonComponent implements OnInit {
  @Input() legacy = '';

  constructor(
    private emailContentService: EmailContentService,
    @Inject(TOKEN_HOLDER) private tokenHolder: TokenHolder
  ) { }

  ngOnInit(): void {
  }

  downloadEnvelope(): void {
    this.emailContentService.downloadEnvelope(this.tokenHolder.value);
  }

  get envelopeLoading(): boolean {
    return this.emailContentService.envelopeLoading;
  }

  get attachmentClass(): string {
    if (this.isLegacy) {
      return 'legacy';
    } else {
      return '';
    }
  }

  get isLegacy(): boolean {
    return this.legacy != null;
  }

  get envelopeDownloadError(): boolean {
    return this.emailContentService.envelopeDownloadError;
  }

  set envelopeDownloadError(value: boolean) {
    this.emailContentService.envelopeDownloadError = value;
  }
}
